// extracted by mini-css-extract-plugin
module.exports = {"container":"B7Q7TLp3jW3je4NlCz1iU"};